import { Injectable } from '@angular/core';
import { IEdlCfDisplayGenericService } from '@edl-development/edl-custom-forms';
import { PaetepCfContextInfoModel } from '../../../item-models/paetep-cf-context-info.model';
import { PaetepCfAnswerContextInfoModel } from '../../../answer-models/paetep-cf-answer-context-info.model';
import { FormBuilder, AbstractControl } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfContextInfoService  implements IEdlCfDisplayGenericService<PaetepCfContextInfoModel, PaetepCfAnswerContextInfoModel> {

  constructor(private formBuilder: FormBuilder) { }

  public buildForm = ({ 
      model,
      answer
  }: { 
      model: PaetepCfContextInfoModel;
      answer?: PaetepCfAnswerContextInfoModel
  }) : AbstractControl | void => this.formBuilder.control(answer, []);

  public buildAnswer = ({
        form,
        model
    } :
    {
        form?: AbstractControl | null,
        model: PaetepCfContextInfoModel
    }) => form?.value;
}
